<div class="dialog" fxLayout="column">

  <div mat-dialog-header>
    <div class="dialog-title" fxLayout="row" fxLayoutAlign="space-between end">
      <div fxLayout="row" fxLayoutGap="10px">
        <mat-icon>create</mat-icon>
        <h1 *ngIf="!isAdded">{{'施設情報：編集' | translate}}</h1>
        <h1 *ngIf="!!isAdded">{{'施設情報：追加' | translate}}</h1>
      </div>

      <div fxLayout="row" fxLayoutGap="8px">
        <button mat-raised-button color="primary" (click)="addFacility()"
          [disabled]="!facilityFormGroup.valid || !isValidSplatsKeyDevices()">
          <mat-icon>add</mat-icon>
          <span *ngIf="!isAdded">{{'更新' | translate}}</span>
          <span *ngIf="!!isAdded">{{'追加' | translate}}</span>
        </button>
        <button mat-button (click)="onNoClick()">
          <mat-icon>clear</mat-icon>
        </button>
      </div>
    </div>
    <div fxLayoutAlign="end">
      <button [ngClass]="{ 'active-menu': display==='home' }" mat-button (click)="onDisplay('home')">
        <mat-icon>dataset</mat-icon>
        {{'ホーム' | translate}}
      </button>
      <button [ngClass]="{ 'active-menu': display==='headerfooter' }" mat-button (click)="onDisplay('headerfooter')">
        <mat-icon>dataset</mat-icon>
        {{'ヘッダー／フッター' | translate}}
      </button>
      <button [ngClass]="{ 'active-menu': display==='apldisp' }" mat-button (click)="onDisplay('apldisp')">
        <mat-icon>dataset</mat-icon>
        {{'アプリ表示' | translate}}
      </button>
      <button [ngClass]="{ 'active-menu': display==='aplope' }" mat-button (click)="onDisplay('aplope')">
        <mat-icon>dataset</mat-icon>
        {{'アプリ運用' | translate}}
      </button>
    </div>
  </div>

  <div mat-dialog-content fxFlex="600px" style="overflow: auto;">
    <form class="form" [formGroup]="facilityFormGroup">


      <!-- ホーム -->
      <div *ngIf="display==='home'" class="icon-text">
        <mat-icon>dataset</mat-icon>
        <span class="pagetitle">{{'ホーム' | translate}}</span>
      </div>
      <div *ngIf="display==='home'" class="pagedesc">{{'主にホーム画面に表示する登録情報を設定します。' | translate}}</div>
      <div *ngIf="display==='home'" class="dialog-body" fxLayout="row" fxLayoutGap="24px">

        <div class="dialog-left" fxLayout="column" fxLayoutGap="20px" fxFlex="100%">
          <div class="categorytitle">{{'▼管理情報（ユーザーアプリ上には表示されません）' | translate}}</div>
          <div fxLayout="row" fxLayoutGap="20px">
            <mat-form-field fxFlex="50%">
              <mat-label floatLabel="always">ID</mat-label>
              <input matInput *ngIf="!isAdded" placeholder="ID" id="facilityId" formControlName="facilityId" readonly>
              <input matInput *ngIf="!!isAdded" placeholder="ID" id="facilityId" formControlName="facilityId">
              <mat-error *ngIf="facilityIdControl.invalid">{{ getErrorMessageToFacilityId() }}</mat-error>
            </mat-form-field>

            <mat-form-field fxFlex="50%">
              <mat-label floatLabel="always">{{'属性' | translate}}</mat-label>
              <mat-select placeholder="{{'属性' | translate}}" id="facilityAttributeId"
                formControlName="facilityAttributeId">
                <mat-option [value]=""></mat-option>
                <mat-option *ngFor="let facilityAttribute of (facilityAttributes | async)"
                  [value]="facilityAttribute.attribute_id">
                  {{ facilityAttribute.attribute_names | multiName:projectLanguages:projectBaseLang }}
                </mat-option>
              </mat-select>
            </mat-form-field>
          </div>

          <div class="categorytitle">{{'▼概要' | translate}}</div>
          <mat-form-field>
            <mat-label floatLabel="always">{{'名称' | translate}}</mat-label>
            <input matInput placeholder="{{'名称' | translate}}" id="facilityNames"
              value="{{ facility!.facility_names | multiName:projectLanguages:projectBaseLang }}" readonly>
            <button matSuffix mat-stroked-button color="primary" (click)="openFacilityNameDialog()">
              <mat-icon>edit</mat-icon>
            </button>
            <mat-error *ngIf="facilityNamesControl.invalid">{{ getErrorMessageToFacilityNames() }}</mat-error>
          </mat-form-field>

          <mat-form-field>
            <mat-label floatLabel="always">{{'詳細' | translate}}</mat-label>
            <textarea matInput placeholder="{{'詳細' | translate}}" id="facilityDescs" rows="3"
              value="{{ facility!.facility_descs | multiDesc:projectLanguages:projectBaseLang }}" readonly></textarea>
            <button matSuffix mat-stroked-button color="primary" (click)="openFacilityDescDialog()">
              <mat-icon>edit</mat-icon>
            </button>
            <mat-error *ngIf="facilityDescsControl.invalid">{{ getErrorMessageToFacilityDescs() }}</mat-error>
          </mat-form-field>

          <div class="categorytitle">{{'▼画像' | translate}}</div>
          <div class="facility-files">
            <div class="facility-files-title" fxLayout="row" fxLayoutAlign="space-between end">
              <span>{{'施設画像ファイル' | translate}}（ {{ !!facility!.facility_files ? facility!.facility_files.length:0 }}
                件）</span>
              <button mat-stroked-button (click)="openSelectFilesDialog()">
                <mat-icon>add</mat-icon>
                <span>{{'ファイル追加' | translate}}</span>
              </button>
            </div>

            <table>
              <thead>
                <tr>
                  <th>{{'画像' | translate}}</th>
                  <th>{{'名称' | translate}}</th>
                  <th style="width: 100px;">{{'言語' | translate}}</th>
                  <th>{{'削除' | translate}}</th>
                </tr>
              </thead>
              <tbody cdkDropList class="cdk-table" (cdkDropListDropped)="onDropFile($event)">
                <tr *ngFor="let facilityFile of facilityFiles; let i=index" cdkDrag cdkDragLockAxis="y">
                  <td><img [src]="facilityFile.download_url" height="40px" width="auto"></td>
                  <td>{{ facilityFile.file_name }}</td>
                  <td>
                    <mat-select id="lang" [value]="facilityFile.lang_code"
                      (selectionChange)="changeFacilityFileLang(i, $event)">
                      <ng-container *ngFor="let language of projectLanguages">
                        <mat-option [value]="language.lang_code">
                          {{ currentLang == 'en' ? (language.lang_name_en ? language.lang_name_en : (language.lang_name
                          | translate)): language.lang_name }}
                        </mat-option>
                      </ng-container>
                    </mat-select>
                  </td>
                  <td>
                    <button mat-stroked-button color="warn" (click)="deleteFiles(i)">
                      <mat-icon>clear</mat-icon>
                    </button>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <mat-checkbox formControlName="notOverlapGuide" color="primary">{{'画像の上に概要（名称や詳細）を重ねない' |
            translate}}</mat-checkbox>
          <mat-checkbox formControlName="facilityFileLink" color="primary"
            [checked]="facility?.facility_file_link">{{'画像タップでメニューを表示する（※登録画像が1つの時に有効）' | translate}}</mat-checkbox>

          <mat-checkbox formControlName="useYoutube" color="primary">{{'YouTubeを使用する' | translate}}</mat-checkbox>
          <div class="mat-form-field-supplement">{{'※チェックONの場合は、次のコードの登録が必要となります。' | translate}}</div>
          <mat-form-field>
            <mat-label floatLabel="always">{{'Youtube埋め込みコード' | translate}}</mat-label>
            <input matInput placeholder="Youtube埋め込みコード" id="youtubeCodes"
              value="{{ facility!.youtube_codes | multiCode:projectLanguages:projectBaseLang }}" readonly>
            <button matSuffix mat-stroked-button color="primary" (click)="openYoutubeCodeDialog()">
              <mat-icon>edit</mat-icon>
            </button>
          </mat-form-field>

          <div class="categorytitle">{{'▼外部リンク' | translate}}</div>
          <mat-checkbox formControlName="useExternallink" color="primary">{{'外部リンクを使用する' | translate}}</mat-checkbox>
          <div class="mat-form-field-supplement">{{'※チェックONの場合は、次の名称とリンクの登録が必要となります。' | translate}}</div>
          <mat-form-field>
            <mat-label floatLabel="always">{{'外部リンク名称' | translate}}</mat-label>
            <input matInput placeholder="外部リンク名称" id="externallinkNames"
              value="{{ facility!.externallink_names | multiName:projectLanguages:projectBaseLang }}" readonly>
            <button matSuffix mat-stroked-button color="primary" (click)="openExternallinkNameDialog()">
              <mat-icon>edit</mat-icon>
            </button>
          </mat-form-field>
          <mat-form-field>
            <mat-label floatLabel="always">{{'外部リンクＵＲＬ' | translate}}</mat-label>
            <input matInput placeholder="外部リンクＵＲＬ" id="externallinkUrls"
              value="{{ facility!.externallink_urls | multiCode:projectLanguages:projectBaseLang }}" readonly>
            <button matSuffix mat-stroked-button color="primary" (click)="openExternallinkUrlDialog()">
              <mat-icon>edit</mat-icon>
            </button>
          </mat-form-field>

        </div>

        <div class="dialog-right" fxLayout="column" fxLayoutGap="20px" fxFlex="100%">

          <div class="categorytitle">{{'▼所在情報' | translate}}</div>
          <google-map *ngIf="center" height="400px" width="100%" step="0.00000001" [center]="center" [zoom]="zoom"
            [options]="options">
            <map-marker #markerElem *ngIf="currentPosition" step="0.00000001" [position]="currentPosition"
              [options]="currentPositionMarkerOption" (mapDragend)="onMerkerDragEnd($event)">
            </map-marker>
          </google-map>
          <input #mapSearchField class="map-search-field" type="text"
            (keydown)="onKeyDownFromSearchPlace($event.keyCode)" />
          <button #mapSearchFieldExecute (click)="searchMap()">{{'移動' | translate}}</button>
          <button #mapSearchFieldClear (click)="clearMapSearchField()">{{'クリア' | translate}}</button>

          <div class="facility-area" fxLayout="row" fxLayoutGap="20px">
            <mat-form-field fxFlex="50%">
              <mat-label floatLabel="always">{{'緯度' | translate}}</mat-label>
              <input matInput placeholder="{{'緯度' | translate}}" id="facilityLat" formControlName="facilityLat"
                type="number" step="0.00000001" (change)="onBlurMarkerLat()">
              <mat-error *ngIf="facilityLatControl.invalid">{{ getErrorMessageToFacilityLat() }}</mat-error>
            </mat-form-field>

            <mat-form-field fxFlex="50%">
              <mat-label floatLabel="always">{{'経度' | translate}}</mat-label>
              <input matInput placeholder="{{'経度' | translate}}" id="facilityLng" formControlName="facilityLng"
                type="number" step="0.00000001" (change)="onBlurMarkerLng()">
              <mat-error *ngIf="facilityLngControl.invalid">{{ getErrorMessageToFacilityLng() }}</mat-error>
            </mat-form-field>
          </div>

          <div class="facility-area" fxLayout="row" fxLayoutGap="20px">
            <mat-form-field fxFlex="50%">
              <mat-label floatLabel="always">{{'地図ズーム初期値(トップ画面)' | translate}}</mat-label>
              <input matInput placeholder="{{'地図ズーム初期値(トップ画面)' | translate}}" id="mapZoomTop"
                formControlName="mapZoomTop" type="number">
              <mat-error *ngIf="mapZoomTopControl.invalid">{{ getErrorMessageToMapZoomTop() }}</mat-error>
            </mat-form-field>

            <mat-form-field fxFlex="50%">
              <mat-label floatLabel="always">{{'地図ズーム初期値(MAP画面)' | translate}}</mat-label>
              <input matInput placeholder="{{'地図ズーム初期値(MAP画面)' | translate}}" id="mapZoomMap"
                formControlName="mapZoomMap" type="number">
              <mat-error *ngIf="mapZoomMapControl.invalid">{{ getErrorMessageToMapZoomMap() }}</mat-error>
            </mat-form-field>
          </div>

          <mat-form-field>
            <mat-label floatLabel="always">{{'GoogleMAP表示タイプ' | translate}}</mat-label>
            <mat-select placeholder="{{'GoogleMAP表示タイプ' | translate}}" id="mapDispType" formControlName="mapDispType">
              <mat-option *ngFor="let mapDispType of mapDispTypes" [value]="mapDispType">{{ mapDispType | typeOfMap
                }}</mat-option>
            </mat-select>
            <mat-error *ngIf="mapDispTypeControl.invalid">{{ getErrorMessageToMapDispType() }}</mat-error>
          </mat-form-field>

          <mat-form-field>
            <mat-label floatLabel="always">{{'電話番号' | translate}}</mat-label>
            <input matInput placeholder="{{'電話番号' | translate}}" id="telephoneNumber" formControlName="telephoneNumber">
          </mat-form-field>

          <mat-form-field>
            <mat-label floatLabel="always">{{'住所' | translate}}</mat-label>
            <textarea matInput placeholder="{{'住所' | translate}}" id="addresses" rows="2"
              value="{{ facility!.addresses | multiAddress:projectLanguages:projectBaseLang }}" readonly></textarea>
            <button matSuffix mat-stroked-button color="primary" (click)="openAddressDialog()">
              <mat-icon>edit</mat-icon>
            </button>
          </mat-form-field>
        </div>
      </div>


      <!-- ヘッダー／フッター -->
      <div *ngIf="display==='headerfooter'" class="icon-text">
        <mat-icon>dataset</mat-icon>
        <span class="pagetitle">{{'ヘッダー／フッター' | translate}}</span>
      </div>
      <div *ngIf="display==='headerfooter'" class="pagedesc">{{'主にヘッダ／フッターに表示する登録情報を設定します。' | translate}}</div>
      <div *ngIf="display==='headerfooter'" class="dialog-body" fxLayout="row" fxLayoutGap="24px">
        <div class="dialog-left" fxLayout="column" fxLayoutGap="20px" fxFlex="100%">
          <div class="categorytitle">{{'▼ヘッダー関連' | translate}}</div>
          <div class="select-favicon-file">
            <div class="favicon-file-title" fxLayout="row" fxLayoutAlign="space-between end">
              <span>{{'faviconファイル' | translate}}</span>
              <button mat-stroked-button (click)="openSelectFaviconFileDialog()">
                <mat-icon>add</mat-icon>
                <span>{{'ファイル選択' | translate}}</span>
              </button>
            </div>
            <table>
              <thead>
                <tr>
                  <th>{{'画像' | translate}}</th>
                  <th>{{'名称' | translate}}</th>
                  <th>{{'削除' | translate}}</th>
                </tr>
              </thead>
              <tr *ngIf="!!faviconFile">
                <td><img [src]="(facility!.favicon_file! | doc:uploadedFilesCollectionName | async)?.download_url"
                    height="40px" width="auto"></td>
                <td>{{ faviconFile.file_name }}</td>
                <td>
                  <button mat-stroked-button color="warn" (click)="deleteFaviconFile()">
                    <mat-icon>clear</mat-icon>
                  </button>
                </td>
              </tr>
            </table>
          </div>

          <div class="select-logo-file">
            <div class="logo-file-title" fxLayout="row" fxLayoutAlign="space-between end">
              <span>{{'ロゴ画像ファイル' | translate}}（ {{ !!facility!.logo_files ?
                facility!.logo_files.length:0 }} {{'件' | translate}}）</span>
              <button mat-stroked-button (click)="openSelectLogoFileDialog()">
                <mat-icon>add</mat-icon>
                <span>{{'ファイル選択' | translate}}</span>
              </button>
            </div>
            <table>
              <thead>
                <tr>
                  <th>{{'画像' | translate}}</th>
                  <th>{{'名称' | translate}}</th>
                  <th style="width: 100px;">{{'言語' | translate}}</th>
                  <th>{{'削除' | translate}}</th>
                </tr>
              </thead>
              <tbody cdkDropList class="cdk-table" (cdkDropListDropped)="onDropLogoFile($event)">
                <tr *ngFor="let logoFile of logoFiles; let i=index" cdkDrag cdkDragLockAxis="y">
                  <td><img [src]="logoFile.download_url" height="40px" width="auto"></td>
                  <td>{{ logoFile.file_name }}</td>
                  <td>
                    <mat-select id="lang" [value]="logoFile.lang_code"
                      (selectionChange)="changeLogoFileLang(i, $event)">
                      <ng-container *ngFor="let language of projectLanguages">
                        <mat-option [value]="language.lang_code">
                          {{ currentLang == 'en' ? (language.lang_name_en ? language.lang_name_en : (language.lang_name
                          | translate)): language.lang_name }}
                        </mat-option>
                      </ng-container>
                    </mat-select>
                  </td>
                  <td>
                    <button mat-stroked-button color="warn" (click)="deleteLogoFiles(i)">
                      <mat-icon>clear</mat-icon>
                    </button>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
        <div class="dialog-right" fxLayout="column" fxLayoutGap="20px" fxFlex="100%">
          <div class="categorytitle">{{'▼フッター関連' | translate}}</div>
          <div class="categorydesc">{{'※未登録の項目はユーザーアプリ上に表示されません。' | translate}}</div>
          <mat-form-field>
            <mat-label floatLabel="always">FAQ</mat-label>
            <textarea matInput placeholder="FAQ" id="faqs" rows="3"
              value="{{ facility!.faqs | multiFaq:projectLanguages:projectBaseLang }}" readonly></textarea>
            <button matSuffix mat-stroked-button color="primary" (click)="openFaqDialog()">
              <mat-icon>edit</mat-icon>
            </button>
          </mat-form-field>
          <mat-form-field>
            <mat-label floatLabel="always">{{'プライバシーポリシー' | translate}}</mat-label>
            <textarea matInput placeholder="プライバシーポリシー" id="policies" rows="3"
              value="{{ facility!.policies | multiPolicy:projectLanguages:projectBaseLang }}" readonly></textarea>
            <button matSuffix mat-stroked-button color="primary" (click)="openPolicyDialog()">
              <mat-icon>edit</mat-icon>
            </button>
          </mat-form-field>
          <mat-form-field>
            <mat-label floatLabel="always">{{'コピーライト' | translate}}</mat-label>
            <textarea matInput placeholder="コピーライト" id="copyrights" rows="3"
              value="{{ facility!.copyrights | multiCopyright:projectLanguages:projectBaseLang }}" readonly></textarea>
            <button matSuffix mat-stroked-button color="primary" (click)="openCopyrightDialog()">
              <mat-icon>edit</mat-icon>
            </button>
          </mat-form-field>

        </div>
      </div>


      <!-- アプリ表示 -->
      <div *ngIf="display==='apldisp'" class="icon-text">
        <mat-icon>dataset</mat-icon>
        <span class="pagetitle">{{'アプリ表示' | translate}}</span>
      </div>
      <div *ngIf="display==='apldisp'" class="pagedesc">{{'ユーザーアプリの表示に関する設定をします。' | translate}}</div>
      <div *ngIf="display==='apldisp'" class="dialog-body" fxLayout="row" fxLayoutGap="24px">

        <div class="dialog-left" fxLayout="column" fxLayoutGap="20px" fxFlex="100%">

          <div class="categorytitle">{{'▼全ページ共通' | translate}}</div>
          <label id="themeColorLabel">{{'テーマカラー' | translate}}</label>
          <mat-radio-group id="themeColor" formControlName="themeColor" aria-labelledby="themeColorLabel">
            <div layout="row" layout-align="center">
              <mat-radio-button fxFlex="25%" value="blue" [checked]="facility!.theme_color === 'blue'">
                <img src="assets/img/facility/theme/Blue.png">
              </mat-radio-button>
              <mat-radio-button fxFlex="25%" value="navyblue" [checked]="facility!.theme_color === 'navyblue'">
                <img src="assets/img/facility/theme/Navy Blue.png">
              </mat-radio-button>
              <mat-radio-button fxFlex="25%" value="beige" [checked]="facility!.theme_color === 'beige'">
                <img src="assets/img/facility/theme/Beige.png">
              </mat-radio-button>
              <mat-radio-button fxFlex="25%" value="red" [checked]="facility!.theme_color === 'red'">
                <img src="assets/img/facility/theme/Red.png">
              </mat-radio-button>
            </div>
            <div layout="row" layout-align="center">
              <mat-radio-button fxFlex="25%" value="black" [checked]="facility!.theme_color === 'black'">
                <img src="assets/img/facility/theme/Black.png">
              </mat-radio-button>
              <mat-radio-button fxFlex="25%" value="orange" [checked]="facility!.theme_color === 'orange'">
                <img src="assets/img/facility/theme/Orange.png">
              </mat-radio-button>
              <mat-radio-button fxFlex="25%" value="green" [checked]="facility!.theme_color === 'green'">
                <img src="assets/img/facility/theme/Green.png">
              </mat-radio-button>
              <mat-radio-button fxFlex="25%" value="gray" [checked]="facility!.theme_color === 'gray'">
                <img src="assets/img/facility/theme/Gray.png">
              </mat-radio-button>
            </div>
          </mat-radio-group>

          <mat-checkbox formControlName="menuStyle" color="primary">{{'メニューアイコンに「メニュー」を表示しない' |
            translate}}</mat-checkbox>

          <div class="categorytitle">{{'▼言語' | translate}}</div>
          <mat-form-field>
            <mat-label floatLabel="always">{{'言語切り替えアイコンイメージ' | translate}}</mat-label>
            <mat-select placeholder="{{'言語切り替えアイコンイメージ' | translate}}" id="languageIconType"
              formControlName="languageIconType">
              <mat-option value="globe">{{'地球儀' | translate}}</mat-option>
              <mat-option value="lang">{{'Lang' | translate}}</mat-option>
            </mat-select>
            <mat-error *ngIf="languageIconTypeControl.invalid">{{ getErrorMessageToLanguageIconType() }}</mat-error>
          </mat-form-field>

          <div class="categorytitle">{{'▼ガイド' | translate}}</div>
          <mat-form-field>
            <mat-label floatLabel="always">{{'「ガイド」の使用について' | translate}}</mat-label>
            <mat-select placeholder="{{'「ガイド」の使用について' | translate}}" id="useGuide" formControlName="useGuide">
              <mat-option *ngFor="let useGuide of useFunctions" [value]="useGuide">{{ useGuide | useFunction
                }}</mat-option>
            </mat-select>
            <mat-error *ngIf="useGuideControl.invalid">{{ getErrorMessageToUseGuide() }}</mat-error>
          </mat-form-field>
          <div class="mat-form-field-supplement-bottom">{{'※カスタムメニューの使用については、建物・カテゴリ情報から登録することができます。' | translate}}
          </div>

          <div class="categorytitle">{{'▼番号入力' | translate}}</div>
          <!-- <mat-checkbox formControlName="unvisibleEnterNum" color="primary">{{'メニューに「番号入力」を表示しない' | translate}}</mat-checkbox> -->
          <mat-form-field>
            <mat-label floatLabel="always">{{'「番号入力」の使用について' | translate}}</mat-label>
            <mat-select placeholder="{{'「番号入力」の使用について' | translate}}" id="useNumberEntry"
              formControlName="useNumberEntry">
              <mat-option *ngFor="let useNumberEntry of useFunctions" [value]="useNumberEntry">{{ useNumberEntry |
                useFunction }}</mat-option>
            </mat-select>
            <mat-error *ngIf="useNumberEntryControl.invalid">{{ getErrorMessageToUseNumberEntry() }}</mat-error>
          </mat-form-field>
          <ng-container *ngIf="useNumberEntryControl.value!==useFunctionNotUsed">
            <mat-checkbox formControlName="useEnterNumTitle" color="primary">{{'メニューの「番号入力」を別名に変更する' |
              translate}}</mat-checkbox>
            <div class="mat-form-field-supplement">{{'※チェックONの場合は、次の別名の登録が必要となります。' | translate}}</div>
            <mat-form-field>
              <mat-label floatLabel="always">{{'「番号入力」別名' | translate}}</mat-label>
              <input matInput placeholder="「番号入力」別名" id="useEnterNumTitles"
                value="{{ facility!.enter_num_titles | multiName:projectLanguages:projectBaseLang }}" readonly>
              <button matSuffix mat-stroked-button color="primary" (click)="openEnterNumTitleDialog()">
                <mat-icon>edit</mat-icon>
              </button>
            </mat-form-field>
            <div class="mat-form-field-supplement">{{'※番号入力ページに表示するメッセージを変更する場合は設定してください。' | translate}}</div>
            <mat-form-field>
              <mat-label floatLabel="always">{{'説明文' | translate}}</mat-label>
              <input matInput placeholder="説明文" id="useEnterNumHelps"
                value="{{ facility!.enter_num_helps | multiName:projectLanguages:projectBaseLang }}" readonly>
              <button matSuffix mat-stroked-button color="primary" (click)="openEnterNumHelpDialog()">
                <mat-icon>edit</mat-icon>
              </button>
            </mat-form-field>
          </ng-container>

          <div class="categorytitle">{{'▼アンケート' | translate}}</div>
          <!-- <mat-checkbox formControlName="visibleEnquete" color="primary">{{'メニューに「アンケート」を表示する' | translate}}</mat-checkbox> -->
          <mat-form-field>
            <mat-label floatLabel="always">{{'「アンケート」の使用について' | translate}}</mat-label>
            <mat-select placeholder="{{'「アンケート」の使用について' | translate}}" id="useQuestion" formControlName="useQuestion">
              <mat-option *ngFor="let useQuestion of useFunctions" [value]="useQuestion">{{ useQuestion | useFunction
                }}</mat-option>
            </mat-select>
            <mat-error *ngIf="useQuestionControl.invalid">{{ getErrorMessageToUseQuestion() }}</mat-error>
          </mat-form-field>

          <ng-container *ngIf="useQuestionControl.value!==useFunctionNotUsed">
            <mat-checkbox formControlName="visibleEnqueteThanks" color="primary">{{'アンケート終了時にありがとうページを表示する' |
              translate}}</mat-checkbox>
            <mat-checkbox formControlName="useEnqueteThanksTitle" color="primary">{{'「アンケートへのご回答ありがとうございました」を変更する' |
              translate}}</mat-checkbox>
            <mat-form-field>
              <mat-label floatLabel="always">{{'アンケートへのご回答ありがとうございました。' | translate}}</mat-label>
              <textarea matInput placeholder="{{'アンケートへのご回答ありがとうございました。' | translate}}" id="enqueteThanksTitles"
                rows="3"
                value="{{ facility!.enquete_thanks_titles | multiTextMessage:projectLanguages:projectBaseLang }}"
                readonly></textarea>
              <button matSuffix mat-stroked-button color="primary" (click)="openEnqueteThanksTitleDialog()">
                <mat-icon>edit</mat-icon>
              </button>
            </mat-form-field>
          </ng-container>

          <div class="categorytitle">{{'▼ランキング' | translate}}</div>
          <!-- <mat-checkbox formControlName="visibleRanking" color="primary">{{'メニューに「ランキング」を表示する' | translate}}</mat-checkbox> -->
          <mat-form-field>
            <mat-label floatLabel="always">{{'「ランキング」の使用について' | translate}}</mat-label>
            <mat-select placeholder="{{'「ランキング」の使用について' | translate}}" id="useRanking" formControlName="useRanking">
              <mat-option *ngFor="let useRanking of useFunctions" [value]="useRanking">{{ useRanking | useFunction
                }}</mat-option>
            </mat-select>
            <mat-error *ngIf="useRankingControl.invalid">{{ getErrorMessageToUseRanking() }}</mat-error>
          </mat-form-field>

          <div class="categorytitle">{{'▼避難所' | translate}}</div>
          <!-- <mat-checkbox formControlName="visibleShelter" color="primary">{{'メニューに「避難所」を表示する' | translate}}</mat-checkbox> -->
          <mat-form-field>
            <mat-label floatLabel="always">{{'「避難所」の使用について' | translate}}</mat-label>
            <mat-select placeholder="{{'「避難所」の使用について' | translate}}" id="useShelter" formControlName="useShelter">
              <mat-option *ngFor="let useShelter of useFunctions" [value]="useShelter">{{ useShelter | useFunction
                }}</mat-option>
            </mat-select>
            <mat-error *ngIf="useShelterControl.invalid">{{ getErrorMessageToUseShelter() }}</mat-error>
          </mat-form-field>

          <div class="categorytitle">{{'▼購入' | translate}}</div>
          <!-- <mat-checkbox formControlName="visiblePaidContent" color="primary">{{'メニューに「購入」を表示する' | translate}}</mat-checkbox> -->
          <mat-form-field>
            <mat-label floatLabel="always">{{'「購入」の使用について' | translate}}</mat-label>
            <mat-select placeholder="{{'「購入」の使用について' | translate}}" id="usePaidContent"
              formControlName="usePaidContent">
              <mat-option *ngFor="let usePaidContent of useFunctions" [value]="usePaidContent">{{ usePaidContent |
                useFunction }}</mat-option>
            </mat-select>
            <mat-error *ngIf="usePaidContentControl.invalid">{{ getErrorMessageToUsePaidContent() }}</mat-error>
          </mat-form-field>
          <ng-container *ngIf="usePaidContentControl.value!==useFunctionNotUsed">
            <!-- <mat-checkbox formControlName="useEnterNumTitle" color="primary">メニューの「番号入力」を別名に変更する</mat-checkbox> -->
            <div class="mat-form-field-supplement">{{'※メニューの「購入」を別名にしたい場合は登録します。' | translate}}</div>
            <mat-form-field>
              <mat-label floatLabel="always">{{'「購入」別名' | translate}}</mat-label>
              <input matInput placeholder="{{'「購入」別名' | translate}}" id="usePurchaseTitles"
                value="{{ facility!.purchase_titles | multiName:projectLanguages }}" readonly>
              <button matSuffix mat-stroked-button color="primary" (click)="openPurchaseTitleDialog()">
                <mat-icon>edit</mat-icon>
              </button>
            </mat-form-field>
          </ng-container>

          <div class="categorytitle">{{'▼全体マップ' | translate}}</div>
          <!-- <mat-checkbox formControlName="visibleAllMap" color="primary">{{'メニューに「全体マップ」を表示する' | translate}}</mat-checkbox> -->
          <mat-form-field>
            <mat-label floatLabel="always">{{'「全体マップ」の使用について' | translate}}</mat-label>
            <mat-select placeholder="{{'「全体マップ」の使用について' | translate}}" id="useAllMap" formControlName="useAllMap">
              <mat-option *ngFor="let useAllMap of useFunctions" [value]="useAllMap">{{ useAllMap | useFunction
                }}</mat-option>
            </mat-select>
            <mat-error *ngIf="useAllMapControl.invalid">{{ getErrorMessageToUseAllMap() }}</mat-error>
          </mat-form-field>

          <ng-container *ngIf="useAllMapControl.value!==useFunctionNotUsed">
            <div class="mat-form-field-supplement">{{'※「現在位置を見る」をタップした時の動作を設定します。' | translate}}</div>
            <mat-form-field>
              <mat-label floatLabel="always">{{'音声制御タイプ' | translate}}</mat-label>
              <mat-select placeholder="音声制御タイプ" id="voiceControlType" formControlName="voiceControlType">
                <mat-option *ngFor="let voiceControlType of voiceControlTypes" [value]="voiceControlType">{{
                  voiceControlType | typeOfVoiceControl }}</mat-option>
              </mat-select>
              <mat-error *ngIf="voiceControlTypeControl.invalid">{{ getErrorMessageToVoiceControlType() }}</mat-error>
            </mat-form-field>
            <div class="mat-form-field-supplement">{{'※マップ上の展示位置（ピン）をタップした時の動作を設定します。' | translate}}</div>
            <mat-form-field>
              <mat-label floatLabel="always">{{'ピンタップ時の音声制御タイプ' | translate}}</mat-label>
              <mat-select placeholder="ピンタップ時の音声制御タイプ" id="pinTapVoiceControlType"
                formControlName="pinTapVoiceControlType">
                <mat-option *ngFor="let pinTapVoiceControlType of pinTapVoiceControlTypes"
                  [value]="pinTapVoiceControlType">{{ pinTapVoiceControlType | typeOfPinTapVoiceControl }}</mat-option>
              </mat-select>
              <mat-error *ngIf="pinTapVoiceControlTypeControl.invalid">{{ getErrorMessageToPinTapVoiceControlType()
                }}</mat-error>
            </mat-form-field>
          </ng-container>

          <div class="categorytitle">{{'▼エントリーフォーム' | translate}}</div>
          <mat-form-field>
            <mat-label floatLabel="always">{{'「エントリーフォーム」の使用について' | translate}}</mat-label>
            <mat-select placeholder="{{'「エントリーフォーム」の使用について' | translate}}" id="useEntryForm"
              formControlName="useEntryForm">
              <mat-option *ngFor="let useEntryForm of useFunctions" [value]="useEntryForm">{{ useEntryForm | useFunction
                }}</mat-option>
            </mat-select>
            <mat-error *ngIf="useEntryFormControl.invalid">{{ getErrorMessageToUseEntryForm() }}</mat-error>
          </mat-form-field>

        </div>

        <div class="dialog-right" fxLayout="column" fxLayoutGap="20px" fxFlex="100%">

          <div class="categorytitle">{{'▼ガイド、フロア・表示グループ' | translate}}</div>
          <div class="categorydesc">{{'※事前にフロア・表示グループ、展示物などの登録が必要です。' |
            translate}}<br>{{'※リスト追加したフロア・表示グループがユーザーアプリに表示されます。' | translate}}</div>
          <div class="floor-list">
            <div class="floor-list-title" fxLayout="row" fxLayoutAlign="space-between end">
              <span>{{'フロア・表示グループリスト' | translate}}（ {{ !!facility!.floor_ids ?
                facility!.floor_ids.length:0 }} {{'件' | translate}}）</span>
              <button mat-stroked-button (click)="openSelectFloorsDialog()">
                <mat-icon>add</mat-icon>
                <span>{{'フロア・表示グループリスト追加' | translate}}</span>
              </button>
            </div>

            <table>
              <thead>
                <tr>
                  <th>ID</th>
                  <th>{{'説明' | translate}}</th>
                  <th>{{'建物・カテゴリ' | translate}}</th>
                  <th>{{'名称' | translate}}</th>
                  <th>{{'削除' | translate}}</th>
                </tr>
              </thead>
              <tbody cdkDropList class="cdk-table" (cdkDropListDropped)="onDropFloor($event)">
                <tr *ngFor="let floor of floors" cdkDrag cdkDragLockAxis="y">
                  <td>{{ floor.floor_id }}</td>
                  <td>{{ floor.floor_explain }}</td>
                  <td>
                    <span *ngFor="let hall of (floor.hall_id | docsByCond:hallsCollectionName:'hall_id' | async)">
                      {{ hall.hall_names | multiName:projectLanguages:projectBaseLang }}
                    </span>
                  </td>
                  <td>{{ floor.floor_names | multiName:projectLanguages:projectBaseLang}}</td>
                  <td>
                    <button mat-stroked-button color="warn" (click)="deleteFloor(floor.id!)">
                      <mat-icon>clear</mat-icon>
                    </button>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <mat-checkbox formControlName="unVisibleBreadcrumb"
            color="primary">{{'ガイド、「フロア・表示グループ」の上部に階層ナビゲーション（パンくずリスト）を表示しない' | translate}}</mat-checkbox>

          <div class="categorytitle">{{'▼展示物' | translate}}</div>
          <mat-checkbox formControlName="visibleGood" color="primary">{{'展示物ページに「いいね」ボタンを表示する' |
            translate}}</mat-checkbox>
          <mat-checkbox formControlName="unVisibleGuideNumber" color="primary">{{'展示物ページの「ガイドへ」「番号入力」ボタンを表示しない' |
            translate}}</mat-checkbox>

        </div>
      </div>

      <!-- アプリ運用 -->
      <div *ngIf="display==='aplope'" class="icon-text">
        <mat-icon>dataset</mat-icon>
        <span class="pagetitle">{{'アプリ運用' | translate}}</span>
      </div>
      <div *ngIf="display==='aplope'" class="pagedesc">{{'ユーザーアプリの運用関連の設定をします。' | translate}}</div>
      <div *ngIf="display==='aplope'" class="dialog-body" fxLayout="row" fxLayoutGap="24px">

        <div class="dialog-left" fxLayout="column" fxLayoutGap="20px" fxFlex="100%">

          <div class="categorytitle">{{'▼Google Search関連' | translate}}</div>
          <mat-form-field>
            <mat-label floatLabel="always">{{'メタキーワード' | translate}}</mat-label>
            <input matInput placeholder="メタキーワード" id="metaKeywords" formControlName="metaKeywords">
          </mat-form-field>

          <mat-form-field>
            <mat-label floatLabel="always">{{'メタディスクリプション' | translate}}</mat-label>
            <input matInput placeholder="メタディスクリプション" id="metaDescription" formControlName="metaDescription">
          </mat-form-field>

          <div class="categorytitle">{{'▼Google Analytics関連' | translate}}</div>
          <mat-form-field>
            <mat-label floatLabel="always">{{'Google Analytics トラッキングコード' | translate}}</mat-label>
            <input matInput placeholder="Google Analytics トラッキングコード" id="googleAnalyticsCode"
              formControlName="googleAnalyticsCode">
          </mat-form-field>

        </div>

        <div class="dialog-right" fxLayout="column" fxLayoutGap="20px" fxFlex="100%">

          <div class="categorytitle">{{'▼QR(URL)生成' | translate}}</div>
          <mat-form-field *ngIf="adminUser">
            <mat-label floatLabel="always">{{'サイトURL(QRコード生成用)' | translate}}</mat-label>
            <input matInput placeholder="{{'サイトURL(QRコード生成用)' | translate}}" id="siteUrl" formControlName="siteUrl">
          </mat-form-field>
          <mat-form-field *ngIf="adminUser">
            <mat-label floatLabel="always">{{'ステージングサイトURL' | translate}}</mat-label>
            <input matInput placeholder="{{'ステージングサイトUR' | translate}}" id="siteUrlStaging"
              formControlName="siteUrlStaging">
          </mat-form-field>

          <div class="categorytitle">{{'▼SPLATSキー' | translate}}</div>
          <div class="facility-files">
            <div class="facility-files-title" fxLayout="row" fxLayoutAlign="space-between end">
              <span>{{ 'SPLATSキーボックス' | translate }}（ {{ !!facility!.splats_key_devices ?
                facility!.splats_key_devices.length:0 }} {{ '件' | translate }}）</span>
              <button mat-stroked-button (click)="appendKeyDevice()">
                <mat-icon>add</mat-icon>
                <span>{{'キーボックス追加' | translate}}</span>
              </button>
            </div>

            <table>
              <thead>
                <tr>
                  <th>{{'環境' | translate}}</th>
                  <th>{{'名称' | translate}}</th>
                  <th>{{'キー数' | translate}}</th>
                  <th>{{'削除' | translate}}</th>
                </tr>
              </thead>
              <tbody cdkDropList class="cdk-table" (cdkDropListDropped)="onDropKeyDevice($event)">
                <tr *ngFor="let keyDevice of facility!.splats_key_devices; let i=index" cdkDrag cdkDragLockAxis="y">
                  <td>
                    <mat-form-field fxFlexFill floatLabel="always">
                      <mat-select [value]="keyDevice.api_type" (selectionChange)="changeKeyDeviceApiType($event, i)">
                        <ng-container *ngFor="let apiType of splatsApiTypes">
                          <mat-option [value]="apiType.key">
                            {{ apiType.value }}
                          </mat-option>
                        </ng-container>
                      </mat-select>
                    </mat-form-field>
                  </td>
                  <td>
                    <mat-form-field fxFlexFill floatLabel="always">
                      <mat-select [value]="keyDevice.id" (selectionChange)="changeKeyDeviceId($event, i)">
                        <ng-container *ngIf="keyDevice.api_type === 1">
                          <ng-container *ngFor="let keyDevice of shareKeyDevices">
                            <mat-option [value]="keyDevice.id">
                              {{ keyDevice.name }}
                            </mat-option>
                          </ng-container>
                        </ng-container>
                        <ng-container *ngIf="keyDevice.api_type === 2">
                          <ng-container *ngFor="let keyDevice of productionKeyDevices">
                            <mat-option [value]="keyDevice.id">
                              {{ keyDevice.name }}
                            </mat-option>
                          </ng-container>
                        </ng-container>
                      </mat-select>
                    </mat-form-field>
                  </td>
                  <td>
                    {{keyDevice.units.length | number}}
                  </td>
                  <td>
                    <button mat-stroked-button color="warn" (click)="deleteKeyDevice(i)">
                      <mat-icon>clear</mat-icon>
                    </button>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>

        </div>
      </div>

    </form>
  </div>


</div>